export default "__VITE_ASSET__Bd4YR4zN__"